var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "v-chart",
        {
          attrs: {
            forceFit: true,
            height: _vm.height,
            data: _vm.dataSource,
            scale: _vm.scale
          }
        },
        [
          _c("v-tooltip"),
          _c("v-axis"),
          _c("v-legend"),
          _c("v-stack-bar", {
            attrs: { position: "name*value", opacity: 1, color: "type" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }